<template>
  <closeable-filter-badge-container
    class="filter-menu-element hover:bg-primary-light hover:text-primary-focus px-3"
    @remove="onRemove"
  >
    <list-filter-value :labels="outcomesLabels"
                       :options="outcomeOptions"
                       :hide-labels="outcomesLabels.length > 1"
                       :label-empty="labelEmpty"
                       class="gap-2"
    >
      <template>
        <span v-if="outcomesLabels.length > 1">{{ label }}</span>
        <chart-legend v-for="outcome in requestOutcomes"
                      :key="outcome"
                      :type="outcome"
                      tooltip-position="bottom"
                      :show-label="false"
                      class="h-4 w-4"
        />
      </template>
    </list-filter-value>
  </closeable-filter-badge-container>
</template>

<script>
import CloseableFilterBadgeContainer from './CloseableFilterBadgeContainer.vue'
import ListFilterValue from '@/components/analytics/filter/ListFilterValue'
import ChartLegend from '@/components/analytics/charts/ChartLegend'

export default {
  name: 'OutcomeFilterBadge',
  components: { CloseableFilterBadgeContainer, ListFilterValue, ChartLegend },

  props: {
    label: {
      type: String,
      required: true
    },
    labelEmpty: {
      type: String,
      required: true
    },
    outcomeOptions: {
      type: Array,
      default: () => []
    },
    requestOutcomes: {
      type: Array,
      default: () => []
    },
    filterItem: {
      type: String,
      default: ''
    }
  },

  computed: {
    outcomesLabels() {
      const selectedOptions = this.outcomeOptions.filter(
        ({ id }) => this.requestOutcomes.includes(id)
      )
      return this.requestOutcomes === null ?
        this.outcomeOptions.map(({ name }) => name) :
        selectedOptions.map(({ name }) => name)
    }
  },

  methods: {
    onRemove() {
      this.$emit('remove', { [this.filterItem]: null })
    }
  }

}
</script>
